// extracted by mini-css-extract-plugin
export default {"container":"Card_container__RVnFN"};